"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiQuoteLeft16 = {
    paths: [
        {
            path: 'M5.76595134,12 L5.76595134,6.24299065 L3.08764227,6.24299065 C3.08764227,5.32086766 3.27701576,4.54205925 3.65576843,3.90654206 C4.03452111,3.27102486 4.73790837,2.79127888 5.76595134,2.46728972 L5.76595134,0 C4.92728471,0.099688972 4.14950071,0.330216262 3.43257601,0.691588785 C2.71565131,1.05296131 2.10018745,1.50778542 1.58616597,2.05607477 C1.07214449,2.60436411 0.673107481,3.23987178 0.389042977,3.96261682 C0.104978474,4.68536187 -0.0235249695,5.45793981 0.00352879279,6.28037383 L0.00352879279,12 L5.76595134,12 Z M14,12 L14,6.24299065 L11.3216909,6.24299065 C11.3216909,5.32086766 11.5110644,4.54205925 11.8898171,3.90654206 C12.2685698,3.27102486 12.971957,2.79127888 14,2.46728972 L14,0 C13.1613334,0.099688972 12.3835494,0.330216262 11.6666247,0.691588785 C10.9497,1.05296131 10.3342361,1.50778542 9.82021463,2.05607477 C9.30619315,2.60436411 8.90715614,3.23987178 8.62309164,3.96261682 C8.33902714,4.68536187 8.21052369,5.45793981 8.23757745,6.28037383 L8.23757745,12 L14,12 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Left Quote',
    width: 14,
    height: 12,
};
var muiQuoteLeft24 = {
    paths: [
        {
            path: 'M9,20 L9,10.4049844 L4.81946149,10.4049844 C4.81946149,8.86811277 5.11505216,7.57009875 5.70624238,6.51090343 C6.2974326,5.4517081 7.39534083,4.65213146 9,4.11214953 L9,0 C7.69093594,0.166148287 6.47690281,0.550360436 5.35786417,1.15264798 C4.23882554,1.75493551 3.27815584,2.5129757 2.47582626,3.42679128 C1.67349668,4.34060685 1.05064489,5.39978629 0.607252228,6.60436137 C0.163859562,7.80893645 -0.0367198252,9.09656636 0.00550804771,10.4672897 L0.00550804771,20 L9,20 Z M22,20 L22,10.4049844 L17.8194615,10.4049844 C17.8194615,8.86811277 18.1150522,7.57009875 18.7062424,6.51090343 C19.2974326,5.4517081 20.3953408,4.65213146 22,4.11214953 L22,0 C20.6909359,0.166148287 19.4769028,0.550360436 18.3578642,1.15264798 C17.2388255,1.75493551 16.2781558,2.5129757 15.4758263,3.42679128 C14.6734967,4.34060685 14.0506449,5.39978629 13.6072522,6.60436137 C13.1638596,7.80893645 12.9632802,9.09656636 13.005508,10.4672897 L13.005508,20 L22,20 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Left Quote',
    width: 22,
    height: 20,
};
var muiQuoteLeft = {
    base: muiQuoteLeft16,
    smIcon: muiQuoteLeft16,
    lgIcon: muiQuoteLeft24,
};
exports.muiQuoteLeft = muiQuoteLeft;
//# sourceMappingURL=quoteLeft.js.map